module.exports = __webpack_public_path__ + "media/images/play-icon-b219c28ff86aace48875d72086f19b74.svg";